<template>
  <b-tab :title="$t('Link Devices to Driver')" lazy>
    <div>
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <div class="d-flex">
        <feather-icon icon="UserIcon" size="19" />
        <h4 class="mb-0 ml-50">
          {{ $t('Link Devices to Driver') }}-{{ data.name }}

        </h4>

        <!-- <table-widget v-if="Object.keys(allItems).length !== 0" :items="allItems" :selected_ids="selectedItems"
        :fields="fields" link_type="driverDevices" :link_to_id="data.id" title="title" /> -->


        <table-widget v-if="Object.keys(allItems).length !== 0" :items="allItems" :selected_ids="selectedItems"
          :fields="fields" link_type="driverDevices" :link_to_id="data.driver_id" title="title" />

      </div>



    </div>
  </b-tab>


</template>

<script>

import {
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BAlert,
  BTab,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import TableWidget from '@/views/widgets/TableWidget.vue';

import { ReportService } from '@/app/reports/share/report.service'
import store from '@/store'
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  directives: {
    Ripple,
  },
  components: {
    BTab,
    BRow,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    vSelect,
    OrbitSpinner,
    TableWidget
  },
  setup(props, { root }) {

    const loading = ref(true)
    const fields = ref([[{ key: 'id', label: 'id' }]])
    const allItems = ref([]);
    const selectedItems = ref([]);

    ReportService.getDevicesOptions({
      type: 'device',
      user: store.state.auth.userData.id
    })
      .then(response => {
        allItems.value = replaceIdByOtherId(response.data)
        loading.value = false
      })

    const replaceIdByOtherId = (data) => {
      const out = data.map((d) => ({ id: d.device_id, name: d.name }))
      return out;
    }

    ReportService.getSelectedLinks({
      type: 'driverDevices',
      driverId: props.data.driver_id
    }).then(response => {

      selectedItems.value = response.ids
    })

    const getData = () => {

    }
    getData();
    return {
      getData,
      allItems,
      fields,
      selectedItems,
      loading,
      replaceIdByOtherId
    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
